import React from "react"
import styled from "styled-components"
import Img from "gatsby-image"
import { setRem, setLetterSpacing, setColor, media } from "../../style"


const BlueBar = ({title, images}) => {

  return (
    <Container>
      <div dangerouslySetInnerHTML={{ __html: title}} />
      <Img fluid={images[5].fluid} className="logo" alt="Trivago" />
      <Img fluid={images[2].fluid} className="logo" alt="Expedia" />
      <Img fluid={images[4].fluid} className="logo " alt="Trip Advisor" />
      <Img fluid={images[3].fluid} className="logo" alt="Hotels.com" />
    </Container>
  )
}

export default BlueBar

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;

  justify-items: center;

  background-color: ${setColor.secondaryColor};
  color: ${setColor.mainWhite};
  font-size: ${setRem(14)};
  font-weight: 400;
  ${setLetterSpacing(2)};
  padding: ${setRem(15)} ${setRem(15)};
  vertical-align: baseline;

  ${media.tablet`
        font-size: ${setRem(30)};    
        
    `}
  ${media.desktop`
  font-size: ${setRem(30)};
  flex-direction: row;
  `}

  b {
    font-weight: bolder;
    text-shadow: 1px 1px grey;
  }

  .logo {
    width: 80px;
    height: auto;

    ${media.tablet`
    width: 141px;
    
    margin-left: ${setRem(10)};
    `}
  }
`
